import { routes } from '@/app/routing/router'
import { XboxProfileView } from './view'
const currentRoute = routes.xboxProfile

const XboxProfileRoute = {
  route: currentRoute,
  view: XboxProfileView,
}

export { currentRoute, XboxProfileRoute }
